import { LINE_DUPLICATE_COUNT, FACTOR_MULTIPLIER } from './constants';

const MoveTo = (x, y) =>
  Array(LINE_DUPLICATE_COUNT)
    .fill()
    .map((_, factor) => ({ x, y, factor: factor * FACTOR_MULTIPLIER }));

export default MoveTo;
